import { MdOutlineCalendarToday } from "react-icons/md";
import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Card from "components/card";
import formatDate from "../../../../../components/actions/ConvertDate";

function padID(id) {
  return String(id).padStart(4, '0');
}
function Invoices(props) {
  const { columnsData, tableData } = props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const abbreviation = sessionStorage.getItem("abbreviation");
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;
  const color1 = " text-green-500 font-medium";
  const color2 = " text-red-500 font-medium";

  return (
    <Card extra={"h-full w-full pt-3 pb-10 px-8"}>

      <h4 className="mb-[22px] ml-px text-lg font-bold text-navy-700 dark:text-white">
        Outstanding Invoices
      </h4>



      <div className="overflow-x-scroll 2xl:overflow-x-hidden">
        <table {...getTableProps()} className="w-full">
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="px-[14px] pt-[0px]"
                    key={index}
                  >
                    <div className="text-left text-xs font-bold uppercase tracking-wide text-gray-600">
                      {column.render("Header")}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()} className="w-full">
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr className="w-full" {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {

                    let data = "";
                    if (cell.column.Header === "Booking Ref") {
                      data = (
                        <div className="flex items-center text-sm font-bold text-navy-700 dark:text-white">
                          {abbreviation + padID(cell.value)}
                        </div>
                      );
                    } else if (cell.column.Header === "Equipment Ref") {
                      data = (
                        <div className="text-sm font-bold text-navy-700 dark:text-white">
                          {cell.value}
                        </div>
                      );
                    }
                    else if (cell.column.Header === "Hire Start") {
                      const date = formatDate(cell.value);
                      data = (
                        <div className="text-sm font-bold text-navy-700 dark:text-white">
                          {date}
                        </div>
                      );
                    }
                    else if (cell.column.Header === "Hire End") {
                      const date = formatDate(cell.value);
                      data = (
                        <div className="text-sm font-bold text-navy-700 dark:text-white">
                          {date}
                        </div>
                      );
                    } else if (cell.column.Header === "Collection  / Delivery Required") {
                      data = (
                        <div
                          className={`text-sm font-bold pl-4 ${cell.value[0] === "Y" ? color2 : color1
                            }`}
                        >
                          {cell.value == true ? "Yes" : "No"
                          }
                        </div>
                      );
                    }
                    return (
                      <td
                        {...cell.getCellProps()}
                        key={index}
                        className="font-xs px-[14px] pt-[19px] pb-[4px]"
                      >
                        {data}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}

export default Invoices;
